import './set-view-product';
import './change-regions';
import './header/init';
import './basket-counters';
import './subscribe-form';
import './front-akc';
import 'swiper/swiper-bundle.css';
import './catalog-block';
import './brands-theme';
import './banner';
import './fat-sales-banners';
import './counter';
import './select';
import './popup';
import './fast_view';
import './catalog-card-common';
import './catalog-card-actions';
import './catalog-card-basket';
import './change-mobile-title';
import './modal-base';
import './modal-ask-question';
import './modal-resume';
import './modal-review';
import './accordion';
import './review';
import './fancybox';
import './plait/bnpl';
import './otp/bnpl';
import './otp/card-informer';
import './catalog/index';
import './basket-fly/init';
import './yandex-map';
import './faq';
import './modal-buy-one-click';
import './modal-report-error';
import './min-price';
import './basket/init';
import './modal-order-service';
import './auth-modal';
import './registration-base';
import './registration-physical';
import './registration-legal';
import './profile';
import './profile-detail';
import './order';
import './profile-change-password';
import './profile-orders';
import './catalog-question';
import './ecommerce';
import {initToolRentalTabs} from './tool-rental-tabs';
import {initDeliveryLiftRates} from './delivery-lift-rates';
import {initB2bPage} from './b2b-page';
function initPageComponents() {
    initToolRentalTabs();
    initDeliveryLiftRates();
    initB2bPage();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageComponents);
} else {
    initPageComponents();
}
